import { BankAccountTypeDisplay } from '@lsq-frontend/common-ui';
import { RedactedBankAccount } from '@lsq-frontend/remote-services/all-java/financing-mk0-services';

export function formatBankAccountForDisplay(
    bankAccount: RedactedBankAccount,
    bankAccountTypeDisplay: BankAccountTypeDisplay
): string {
    return `${
        bankAccount.bankAccountType
            ? bankAccountTypeDisplay[bankAccount.bankAccountType]
            : bankAccountTypeDisplay['ACH']
    } - ${bankAccount.accountName} (${bankAccount.redactedAccountNumber.replace('******', '...')})`;
}
